import { Alert } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { useContext, useRef } from "react";
import { localeText } from "../../../../../actions/datagrid.js";
import { useTranslation } from "react-i18next";
import "ag-grid-enterprise";
import { NewEventForm } from "./NewEventForm.jsx";
import { SettingsProcountorContext } from "../SettingsProcountorContext.jsx";
import { getContextMenuItemsForMappings } from "../SettingsProcountor.constants.ts";
import { useGetAllAbsenceSalaryMappings } from "../../../../../api/endpoints/index.ts";
import { useGetColumnsForEventMapping } from "./useGetColumnsForEventMapping";

const defaultColDef = {
  resizable: true,
  sortable: true,
  editable: true,
  singleClickEdit: true,
  flex: 1,
};

export const EventMapping = ({ integration }) => {
  const { t, i18n } = useTranslation();
  const gridRef = useRef(null);
  const context = useContext(SettingsProcountorContext) || {};
  const { editedCells = [], setEditedCells = () => { } } = context;

  const columnDefs = useGetColumnsForEventMapping(integration);
  const { data: mappingsData, refetch } = useGetAllAbsenceSalaryMappings();

  const filteredData = mappingsData?.filter((item) => item.payrollSystemType === integration);

  const editCells = (cell) => {
    const changedCells = [...editedCells];
    const editedCellIndex = editedCells.map(({ id }) => id).indexOf(cell.id);

    if (editedCellIndex > -1) {
      changedCells[editedCellIndex] = cell;
    } else {
      changedCells.push(cell);
    }
    setEditedCells(changedCells);
  };

  return (
    <div id="event-mapping-table">
      <Alert className="w-auto d-inline-block">
        {t("benefitMapping.editInfo", "To edit fields, simply click on them")}
      </Alert>
      <div className="ag-theme-material ag-event-mapping styles-ag mb-3" style={{ height: "500px", marginRight: "0" }}>
        <AgGridReact
          ref={gridRef}
          defaultColDef={defaultColDef}
          columnDefs={columnDefs}
          rowData={filteredData}
          getRowId={(params) => String(params.data.id)}
          localeText={localeText(i18n)}
          debug={import.meta.env.DEV}
          onCellValueChanged={(event) => editCells(event.data)}
          defaultExcelExportParams={{ exportAsExcelTable: true }}
          defaultCsvExportParams={{ columnSeparator: ";" }}
          getContextMenuItems={getContextMenuItemsForMappings}
        />
      </div>
      <NewEventForm refetch={refetch} integration={integration} />
    </div>
  );
};
